module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.103/js/sprocket_white.svg"